(() => {
  const SWIPE_THRESHOLD = 48;
  const SWIPE_MAX_VERTICAL = 96;
  const SWIPE_EDGE_PX = 32;
  const SWIPE_VIEWPORT = '(max-width: 989px)';

  const isInteractive = (target) =>
    target?.closest(
      'a, button, input, select, textarea, label, summary, [role="button"], .quantity__button, .shopify-payment-button'
    );

  const isHorizontalCarousel = (target) =>
    target?.closest(
      '.product__media-list, [id^="Slider-"], slideshow-component, .complementary-products-grid, .complementary-slider'
    );

  const isChromeExcluded = (target) =>
    target?.closest('.cart-drawer, .header, .menu-drawer, .facet-filters, #CartDrawer');

  const isPackComposer = (target) => target?.closest('pack-composer');

  const canStartSwipe = (clientX, target) => {
    if (isPackComposer(target) || isInteractive(target) || isChromeExcluded(target)) return false;
    if (clientX <= SWIPE_EDGE_PX) return true;
    return !isHorizontalCarousel(target);
  };

  const init = () => {
    if (!window.matchMedia(SWIPE_VIEWPORT).matches) return;

    const url = document.querySelector('[data-boutique-swipe-url]')?.dataset.boutiqueSwipeUrl;
    if (!url) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;
    let navigating = false;

    const navigate = () => {
      if (navigating) return;
      navigating = true;
      window.location.assign(url);
    };

    const reset = () => {
      tracking = false;
    };

    const onStart = (clientX, clientY, target) => {
      if (!canStartSwipe(clientX, target)) return;
      startX = clientX;
      startY = clientY;
      tracking = true;
    };

    const onMove = (clientX, clientY) => {
      if (!tracking) return;

      const deltaX = clientX - startX;
      const deltaY = clientY - startY;
      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 14) {
        reset();
      }
    };

    const onEnd = (clientX, clientY) => {
      if (!tracking) return;
      reset();

      const deltaX = clientX - startX;
      const deltaY = clientY - startY;
      if (deltaX >= SWIPE_THRESHOLD && Math.abs(deltaY) <= SWIPE_MAX_VERTICAL) {
        navigate();
      }
    };

    document.addEventListener(
      'touchstart',
      (event) => {
        if (navigating || event.touches.length > 1) return;
        const touch = event.touches[0];
        if (!touch) return;
        onStart(touch.clientX, touch.clientY, event.target);
      },
      { passive: true, capture: true }
    );

    document.addEventListener(
      'touchmove',
      (event) => {
        if (!tracking || !event.touches[0]) return;
        onMove(event.touches[0].clientX, event.touches[0].clientY);
      },
      { passive: true, capture: true }
    );

    document.addEventListener(
      'touchend',
      (event) => {
        if (!tracking) return;
        const touch = event.changedTouches[0];
        if (!touch) return;
        onEnd(touch.clientX, touch.clientY);
      },
      { passive: true, capture: true }
    );

    document.addEventListener('touchcancel', reset, { passive: true, capture: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
